var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreateIcon18 = function SvgCreateIcon18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 24,
    fill: "#000",
    fillOpacity: 0.3,
    rx: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 23,
    x: 0.5,
    y: 0.5,
    stroke: "#fff",
    strokeOpacity: 0.7,
    rx: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.295 6.364V18H9.886V7.841h-.068l-2.84 1.886V8.296l2.908-1.932zM18.37 18.16q-1.171 0-2.069-.416-.892-.42-1.392-1.153a2.9 2.9 0 0 1-.494-1.682 3.1 3.1 0 0 1 .29-1.363q.295-.63.806-1.051.518-.427 1.154-.54v-.068q-.835-.216-1.33-.938a2.84 2.84 0 0 1-.488-1.653 2.8 2.8 0 0 1 .448-1.586q.455-.698 1.25-1.102.801-.403 1.824-.403 1.012 0 1.807.403.795.405 1.25 1.102.46.7.466 1.586a2.9 2.9 0 0 1-.506 1.653q-.495.722-1.312.938v.068q.631.113 1.136.54.505.42.807 1.05.3.626.307 1.364a2.94 2.94 0 0 1-.512 1.682q-.5.733-1.392 1.153-.886.415-2.05.415m0-1.25q.789 0 1.363-.256a2.03 2.03 0 0 0 .886-.722q.313-.466.319-1.09a2.1 2.1 0 0 0-.341-1.166 2.3 2.3 0 0 0-.915-.795 2.9 2.9 0 0 0-1.313-.29q-.744 0-1.33.29a2.3 2.3 0 0 0-.914.795q-.33.506-.324 1.165-.005.625.301 1.091.313.465.892.722.58.255 1.375.255m0-5.523q.624 0 1.107-.25.49-.25.767-.7.279-.448.284-1.05a1.94 1.94 0 0 0-.278-1.029 1.8 1.8 0 0 0-.756-.682 2.46 2.46 0 0 0-1.125-.244q-.653 0-1.142.244-.489.24-.755.682a1.9 1.9 0 0 0-.262 1.029q-.006.601.267 1.05.28.45.767.7.489.25 1.125.25M26.766 5.846h.952v3.052h3.052v.952h-3.052v3.066h-.952V9.85H23.7v-.952h3.066z"
  })));
};
export default SvgCreateIcon18;